module.exports = __webpack_public_path__ + "img/thumbnail.1d7601b3.png";